var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { NavigationHelper } from "./NavigationHelper";
const _subPageToRoutes = {
    HOME: NamedRoutes.ACCOUNT_SETTINGS,
    PROFILE: NamedRoutes.ACCOUNT_SETTINGS_PROFILE,
    LOGIN_AND_SECURITY: NamedRoutes.ACCOUNT_SETTINGS_LOGIN_AND_SECURITY,
    ABOUT_YOUR_ORG: NamedRoutes.ACCOUNT_SETTINGS_ABOUT_YOUR_ORG,
};
const subPageToRoutes = _subPageToRoutes;
export class AccountSettingsUIManager {
    constructor(routingUIManager) {
        this.routingUIManager = routingUIManager;
        this.navigationHelper = new NavigationHelper(this.routingUIManager, subPageToRoutes);
        routingUIManager.registerRedirect(NamedRoutes.ACCOUNT_SETTINGS, () => {
            return NamedRoutes.ACCOUNT_SETTINGS_PROFILE;
        });
    }
    get currentSubPage() {
        return this.navigationHelper.currentNavigationItem;
    }
    setCurrentSubPage(subPage) {
        this.navigationHelper.navigateTo(subPage);
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsUIManager.prototype, "currentSubPage", null);
